import ImageDetailsModel from 'src/app/services/images-details.model';
import CustomerPondModel from 'src/app/services/customerPond.model';
import PondCultureModel from 'src/app/services/pondCulture.model';
import PondSectionModel from 'src/app/services/pondSection.model';
import SpeciesTypeModel from 'src/app/services/speciesType.model';
import HarvestLogModel from 'src/app/services/harvestLog.model';
import ObservationLogModel from 'src/app/services/observationLog.model';
import ReadingsModel from 'src/app/services/readings.model';
import SamplingModel from 'src/app/services/sampling.model';
import BusinessEntity from 'src/app/services/businessEntity.model';
import FarmSiteModel from 'src/app/services/farmSite.model';
import PersonsModel from 'src/app/services/persons.model';
import FeedLogModel from './feedLog.model';
import TreatmentLogModel from './treatmentLog.model';

export default class LandingPageModel {
  imagesList: Array<ImageDetailsModel>;
  currentDayCustomerPonds: Array<CustomerPondModel>;
  activeCustomerPonds: Array<CustomerPondModel>;
  inActiveCustomerPonds: Array<CustomerPondModel>;
  pondCultures: Array<PondCultureModel>;
  pondSections: Array<PondSectionModel>;
  originalPondSections: Array<PondSectionModel>;
  businessEntity: BusinessEntity;
  businessEntities: Array<BusinessEntity>;
  providerBusinessEntities: Array<BusinessEntity>;
  farmSites: Array<FarmSiteModel>;
  currentDayFarmSites: Array<FarmSiteModel>;
  farmSitesByBusinessId: Array<FarmSiteModel>;
  feedLogs: Array<FeedLogModel>;
  feedLogsWithFarmSite: Array<FeedLogModel>;
  originalFeedLogsWithFarmSite: Array<FeedLogModel>;
  treatmentLogs: Array<TreatmentLogModel>;
  samplings: Array<SamplingModel>;
  harvestLogs: Array<HarvestLogModel>;
  observationLogs: Array<ObservationLogModel>;
  speciesTypes: Array<SpeciesTypeModel>;
  speciesType: SpeciesTypeModel;
  persons: Array<PersonsModel>;
  readings: Array<ReadingsModel>;
  inActivePondsCount: number;
  inActiveStockingCount: number;
  inActiveArea: number;
  activePondCount: number;
  activeStockingCount: number;
  activeArea: number;
  farmsCount: number;
  waterQualityTest: number;
  imageCount: number;

  constructor() { }
}
